/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsCategories
 */
export interface ControlcenterMelcoModelsCategories {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCategories
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCategories
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCategories
     */
    category_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCategories
     */
    asset_url?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCategories
     */
    publish_state: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCategories
     */
    created_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCategories
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCategories
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsCategories
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
}

export function ControlcenterMelcoModelsCategoriesFromJSON(json: any): ControlcenterMelcoModelsCategories {
    return ControlcenterMelcoModelsCategoriesFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsCategories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'category_type': !exists(json, 'category_type') ? undefined : json['category_type'],
        'asset_url': !exists(json, 'asset_url') ? undefined : json['asset_url'],
        'publish_state': json['publish_state'],
        'created_date': (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
    };
}

export function ControlcenterMelcoModelsCategoriesToJSON(value?: ControlcenterMelcoModelsCategories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'category_type': value.category_type,
        'asset_url': value.asset_url,
        'publish_state': value.publish_state,
        'created_date': (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
    };
}


